<script lang="ts">
  import { _ } from 'svelte-i18n';
  import { fade } from 'svelte/transition';
  import { createEventDispatcher } from 'svelte';
  import { debugLog } from '../../lib/debug-log';

  const dispatch = createEventDispatcher();

  export let showContactUs = false;

  export let showThankyouMessage = false;

  const personalInformation = JSON.parse(
    localStorage.getItem('personalInformation') as string,
  );

  let name = personalInformation?.name || '';
  let email = personalInformation?.email || '';
  let message = '';
  let form: HTMLFormElement;

  let submitting = false;

  const submitForm = async () => {
    try {
      form.reportValidity();
      submitting = true;

      let information = localStorage.getItem('receipt');
      debugLog(name, email, message, information);
      await fetch(
        'https://ixsqdtzqhrw3pafgywqtdaa2zy0cmaht.lambda-url.eu-central-1.on.aws/notify-admin',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            name,
            email,
            message,
            information,
          }),
        },
      );
      submitting = false;
    } catch (e) {
      debugLog(e);
    }
    form.reset();
    dispatch('submit');
    showThankyouMessage = true;
  };
</script>

<div
  class="fixed inset-0 z-[9999] overflow-y-auto"
  aria-labelledby="modal-title"
  role="dialog"
  aria-modal="true"
  transition:fade={{ delay: 0, duration: 200 }}
>
  <div
    class="flex min-h-screen items-center justify-center px-4 pt-4 pb-20 text-center sm:p-0"
  >
    <div
      class="fixed inset-0 bg-gray-500 bg-opacity-75"
      aria-hidden="true"
    ></div>

    <div
      class="inline-block w-full transform overflow-hidden rounded-lg bg-white text-left align-bottom shadow-xl transition-all sm:my-8 sm:max-w-4xl sm:align-middle"
    >
      <div class="w-full bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
        <div class="w-full sm:flex sm:items-start">
          <div class="mt-3 w-full text-center sm:mt-0 sm:ml-4 sm:text-left">
            <div class="absolute top-0 right-0 pt-2 pr-2">
              <button
                class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                on:click={() => (showContactUs = false)}
                type="button"
              >
                <span class="sr-only"> Close </span>
                <svg
                  class="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                  ><path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  /></svg
                >
              </button>
            </div>
            <div class="mt-5 flex flex-col gap-2 text-center">
              <h3
                class="font-CorpoA text-2xl font-medium leading-6 text-gray-900"
                id="modal-title"
              >
                {$_('Feel free to contact us.')}
              </h3>

              <h2 class="font-sans text-gray-600">
                {$_(
                  "Sometimes things don't go as smoothly as we planned. If you are unable to complete the application process via the online portal, our service team is at your disposal.",
                )}
              </h2>

              <h2 class="font-sans text-gray-600">
                {$_('You are welcome to inform us about your concerns here.')}
              </h2>
              <h2 class="font-sans text-gray-600">
                {$_('We will get back to you shortly.')}
              </h2>
            </div>

            <div class="mt-2 font-sans">
              <form on:submit|preventDefault={submitForm} bind:this={form}>
                <div>
                  <label
                    for="fullname"
                    class="block text-sm font-medium text-gray-700"
                  >
                    {$_('Full Name')} <span class="align-top">*</span>
                  </label>
                  <div class="mt-1">
                    <input
                      type="text"
                      name="fullname"
                      id="fullname"
                      class="block w-full rounded-md border-gray-300 bg-gray-200 p-3 shadow-sm focus:border-primary-500 focus:ring-primary-500"
                      bind:value={name}
                      required
                    />
                  </div>
                </div>
                <div class="mt-4">
                  <label
                    for="email"
                    class="block text-sm font-medium text-gray-700"
                  >
                    {$_('Email')} <span class="align-top">*</span>
                  </label>
                  <div class="mt-1">
                    <input
                      type="email"
                      name="email"
                      id="email"
                      class="block w-full rounded-md border-gray-300 bg-gray-200 p-3 shadow-sm focus:border-primary-500 focus:ring-primary-500"
                      bind:value={email}
                      required
                    />
                  </div>
                </div>
                <div class="mt-4">
                  <label
                    for="message"
                    class="block text-sm font-medium text-gray-700"
                  >
                    {$_('Message')} <span class="align-top">*</span>
                  </label>
                  <div class="mt-1">
                    <textarea
                      id="message"
                      name="message"
                      rows="3"
                      class="block w-full rounded-md border-gray-300 bg-gray-200 p-3 shadow-sm focus:border-primary-500 focus:ring-primary-500"
                      bind:value={message}
                      required
                    ></textarea>
                  </div>
                  <div class="mt-2">
                    <p class="text-sm text-red-500">
                      * {$_('required')}
                    </p>
                  </div>
                  <div class="py-3 sm:flex">
                    <button
                      class="inline-flex w-full justify-center rounded-md border border-transparent bg-primary-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 {submitting
                        ? 'pointer-events-none cursor-not-allowed !bg-gray-400 opacity-50'
                        : ''}"
                      type="submit"
                      disabled={submitting}
                    >
                      {$_('Send')}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
